var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { AuAction } from '../../action/au.action';
import { MessageService } from '../../service/message.service';
import { PageService } from '../../models/page.service';
import { ContentBaseComponent } from '../base/contentbase.component';
import { ContentBaseService } from '../base/contentbase.service';
var EntryComponent = /** @class */ (function (_super) {
    __extends(EntryComponent, _super);
    function EntryComponent(router, route, logger, action, message, page, service) {
        var _this = _super.call(this, router, route, logger, action, message, page, service) || this;
        _this.router = router;
        _this.route = route;
        _this.logger = logger;
        _this.action = action;
        _this.message = message;
        _this.page = page;
        _this.service = service;
        _this.dispRec = {};
        return _this;
    }
    EntryComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
        this.setCompRec();
    };
    EntryComponent.prototype.onInit = function (meta) {
        _super.prototype.onInit.call(this, meta);
        if (this.cols.length > 0 && this.component.params && this.component.params.horizontal === true) {
            for (var _i = 0, _a = this.cols; _i < _a.length; _i++) {
                var col = _a[_i];
                $.extend(true, col, { params: { formClass: { horizontal: true } } });
            }
        }
        this.orgCols = $.extend(true, [], this.cols);
    };
    EntryComponent.prototype.setUnsubscribe = function () {
        this.eventSubscription.unsubscribe();
        this.changeSubscription.unsubscribe();
    };
    EntryComponent.prototype.onModeSubscribe = function (mode) {
        this.cols = $.extend(true, [], this.orgCols);
        if (mode === 'confirm') {
            this.setConfirm(this.cols);
        }
    };
    EntryComponent.prototype.setConfirm = function (cols) {
        for (var _i = 0, cols_1 = cols; _i < cols_1.length; _i++) {
            var col = cols_1[_i];
            if (!col.items) {
                if (col.readonly || (!col.readonly && !col.hidden)) {
                    col.readonly = true;
                }
            }
            else {
                this.setConfirm(col.items);
            }
        }
    };
    EntryComponent.prototype.onSubscribe = function (data) {
        this.rec = {};
        this.dispRec = {};
        this.setRecs(this.cols, data);
        this.setCompRec();
    };
    EntryComponent.prototype.setRecs = function (cols, data) {
        for (var _i = 0, cols_2 = cols; _i < cols_2.length; _i++) {
            var col = cols_2[_i];
            if (col.items) {
                for (var _a = 0, _b = col.items; _a < _b.length; _a++) {
                    var item = _b[_a];
                    this.setRec(item.key, col.readonly ? col.readonly : item.readonly, item.hidden, item.params, data);
                }
            }
            else {
                this.setRec(col.key, col.readonly, col.hidden, col.params, data);
                if (typeof col.params !== 'undefined' && typeof col.params.switch !== 'undefined') {
                    var items = jsonpath.query(col.params.switch, '$..items');
                    for (var _c = 0, items_1 = items; _c < items_1.length; _c++) {
                        var item = items_1[_c];
                        for (var _d = 0, item_1 = item; _d < item_1.length; _d++) {
                            var itm = item_1[_d];
                            this.setRec(itm.key, col.readonly ? col.readonly : itm.readonly, itm.hidden, itm.params, data);
                        }
                    }
                }
                if (col.controlType === 'displayTarget') {
                    var keys = jsonpath.query(col, '$..key');
                    for (var _e = 0, keys_1 = keys; _e < keys_1.length; _e++) {
                        var k = keys_1[_e];
                        this.setRec(k, col.readonly, col.hidden, col.params, data);
                    }
                }
                //// kts
                if (col.controlType === 'constructionClassification') {
                    var keys = jsonpath.query(col, '$..key');
                    for (var _f = 0, keys_2 = keys; _f < keys_2.length; _f++) {
                        var k = keys_2[_f];
                        this.setRec(k, col.readonly, col.hidden, col.params, data);
                    }
                }
                else if (col.controlType === 'department') {
                    var keys = jsonpath.query(col, '$..key');
                    for (var _g = 0, keys_3 = keys; _g < keys_3.length; _g++) {
                        var k = keys_3[_g];
                        this.setRec(k, col.readonly, col.hidden, col.params, data);
                    }
                }
                if (typeof col.params !== 'undefined' && typeof col.params.fileName !== 'undefined' && typeof col.params.fileName.displayFileKey !== 'undefined') {
                    // console.log("★displayFileKey")
                    this.setRec(col.params.fileName.displayFileKey, true, true, col.params, data);
                }
            }
        }
    };
    EntryComponent.prototype.setRec = function (key, readonly, hidden, params, data) {
        if (typeof key === 'undefined') {
            return;
        }
        if (typeof params !== 'undefined' && typeof params.initValue !== 'undefined') {
            this.dispRec[key] = params.initValue;
        }
        if (typeof data[key] !== 'undefined') {
            this.dispRec[key] = data[key];
        }
        else if (typeof this.dispRec[key] === 'undefined') {
            this.dispRec[key] = null;
        }
        if (typeof this.dispRec[key] !== 'undefined' && (!readonly || hidden)) {
            this.rec[key] = this.dispRec[key];
        }
    };
    EntryComponent.prototype.onEvent = function (e1, e2, rec) {
    };
    EntryComponent.prototype.onChange = function (e) {
        this.dispRec[e.key] = e.val;
        this.rec[e.key] = e.val;
        this.setCompRec();
    };
    EntryComponent.prototype.onClick = function (e) {
        this.action.firstAction(e.event, { buttonType: e.type });
    };
    EntryComponent.prototype.setCompRec = function () {
        this.action.setCompRec(this.componentName, this.rec);
    };
    EntryComponent.decorators = [
        { type: Component, args: [{
                    moduleId: module.id.toString(),
                    selector: 'entry',
                    template: "<form id=\"{{ componentName }}\">\n  <ng-template ngFor let-col [ngForOf]=\"cols\" let-index=\"index\" [ngForTrackBy]=\"trackByCol\">\n    <ng-template [ngIf]=\"col.readonly || (!col.readonly && !col.hidden)\" [ngIfElse]=\"elseBlock\">\n      <div class=\"row\" [class.-mb-1]=\"index < cols.length - 1\">\n        <div class=\"col-sm-12\">\n          <column [key]=\"'form'\" [componentName]=\"componentName\" [col]=\"col\" [val]=\"dispRec\" [msg]=\"(msg | async)\" (setChangeVal)=\"onChange($event)\" (clickCol)=\"onClick($event)\"></column>\n        </div>\n      </div>\n    </ng-template>\n    <ng-template #elseBlock>\n      <columngroup [componentName]=\"componentName\" [col]=\"col\" [val]=\"dispRec\" (changeVal)=\"onChange($event)\"></columngroup>\n    </ng-template>\n  </ng-template>\n</form>\n"
                }] }
    ];
    /** @nocollapse */
    EntryComponent.ctorParameters = function () { return [
        { type: Router },
        { type: ActivatedRoute },
        { type: NGXLogger },
        { type: AuAction },
        { type: MessageService },
        { type: PageService },
        { type: ContentBaseService }
    ]; };
    return EntryComponent;
}(ContentBaseComponent));
export { EntryComponent };
//# sourceMappingURL=entry.component.js.map